import { configureStore as configureStoreRtk } from '@reduxjs/toolkit';

import { rootReducer } from '../../reducers';

function configureStore(preloadedState) {
    return configureStoreRtk({
        reducer: rootReducer(),
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                // TODO Moment.js objects are not serializable, and not immutable. We are getting absolutely spammed by the warnings
                //   Disabling those warnings has quite a big performance impact.
                //   Converting the whole model to e.g. iso date strings would be a lot of work, while only looking a bit nicer
                //   Using unserializable objects is possible and works, just some minor problem when persisting
                immutableCheck: false,
                serializableCheck: false,
            }),
        preloadedState,
        devTools: true,
    });
}

const store = configureStore();

export { store, configureStore };
